document.addEventListener('DOMContentLoaded', () => {
  const thumbs = document.querySelectorAll('.cph-thumb');
  const mainImg = document.getElementById('cph-main-img');
  const prevBtn = document.getElementById('cph-prev-btn');
  const nextBtn = document.getElementById('cph-next-btn');

  let currentIndex = 0;

  function updateMainImage(index) {
    const selected = thumbs[index];
    mainImg.src = selected.src.replace('200x', '800x');

    thumbs.forEach(t => t.classList.remove('active'));
    selected.classList.add('active');

    currentIndex = index;
  }

  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => updateMainImage(idx));
  });

  prevBtn.addEventListener('click', () => {
    currentIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
    updateMainImage(currentIndex);
  });

  nextBtn.addEventListener('click', () => {
    currentIndex = (currentIndex + 1) % thumbs.length;
    updateMainImage(currentIndex);
  });

});